import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import useAxios from 'axios-hooks';
import ApiKeysTable from '../Components/ApiKeysTable';
import Toast from '../../../../Forms/Toast';

const DefaultApiKeysPage = () => {
    const history = useHistory();
    const [selectedApiKey, setSelectedApiKey] = useState(null);
    const [showToast, setShowToast] = useState(false);

    const [{ data: apiKeys, loading }, refetch] = useAxios('/api-admin/keys');

    const [, deleteKey] = useAxios(
        { method: 'DELETE' },
        { manual: true }
    );

    const editOnClick = (keySid) => {
        history.push(`/client-settings-feature/api-keys/${keySid}/wizard`);
    };

    const createOnClick = () => {
        history.push('/client-settings-feature/api-keys/wizard');
    };

    const deleteOnClick = async (keySid) => {
        try {
            await deleteKey({
                url: `/api-admin/keys/${keySid}`,
            });
            setShowToast(true);
            refetch();
        } catch (error) {
            console.error('Error deleting API key:', error);
        }
    };

    return (
        <>
            <ApiKeysTable
                apiKeys={apiKeys}
                setSelectedApiKey={setSelectedApiKey}
                loading={loading}
                editOnClick={editOnClick}
                createOnClick={createOnClick}
                deleteOnClick={deleteOnClick}
            />
            {showToast && (
                <Toast
                    message="API Key deleted successfully"
                    onDismiss={() => setShowToast(false)}
                />
            )}
        </>
    );
};

export default DefaultApiKeysPage;
